import { Divider, Flex, GoodsCarouselSkeleton, List } from '@banhala/ui-kit';
import { CodiGoodsCarousel } from './CodiGoodsCarousel';
import { MidRelatedRecommendAdGoodsCarousel } from './MidRelatedRecommendAdGoodsCarousel';
import React, { useMemo } from 'react';
import Animated from 'react-native-reanimated';
import { useCodiGoodsList } from './queries/useCodiGoodsList';
import { useMidRelatedRecommendGoodsList } from './queries/useMidRelatedRecommendGoodsList';
import { isNotNil } from 'shared/src/utils';
import { useElementViewportTracking } from '../../store/sectionVisibility';
const CarouselDivider = () => <Divider size={'small'} />;

export const GoodsCarouselContent = () => {
  const trackingRef = useElementViewportTracking('carousel');
  const { data: codiGoods } = useCodiGoodsList();
  const { data: midRelatedRecommend } = useMidRelatedRecommendGoodsList();
  const lists = useMemo<('codi' | 'mid-ad')[]>(
    () =>
      [
        (codiGoods.codi_goods?.item_list ?? []).length > 0
          ? ('codi' as const)
          : null,
        midRelatedRecommend.item_list.length > 0 ? ('mid-ad' as const) : null,
      ].filter(isNotNil),
    [codiGoods, midRelatedRecommend],
  );
  return (
    <Animated.View ref={trackingRef}>
    <List<'codi' | 'mid-ad'>
      data={lists}
      // onViewableItemsChanged={onViewableItemsChanged}
      ItemSeparatorComponent={CarouselDivider}
      renderItem={({ item }) => {
        if (item === 'codi') {
          return <CodiGoodsCarousel />;
        }

        if (item === 'mid-ad') {
          return <MidRelatedRecommendAdGoodsCarousel />;
        }

        return null;
      }}
      ListFooterComponent={<Divider size={'medium'} />}
    />
    </Animated.View>
  );
};

export const GoodsCarousel = () => {
  return (
    <React.Suspense
      fallback={
        <Flex>
          <Flex.Row
            padding={{ horizontal: 16, vertical: 16 }}
            alignItems={'center'}
            justifyContent={'space-between'}
          >
            <Flex
              backgroundColor={'bg_tertiary'}
              width={98}
              height={24}
              borderRadius={4}
            ></Flex>
            <Flex
              backgroundColor={'bg_tertiary'}
              width={64}
              height={18}
              borderRadius={4}
            ></Flex>
          </Flex.Row>
          <GoodsCarouselSkeleton count={4} />
        </Flex>
      }
    >
      <Flex>
        <GoodsCarouselContent />
        <CarouselDivider />
      </Flex>
    </React.Suspense>
  );
};
